//import $ from 'jquery';
import Theme from './front-components/theme';
//import * as bootstrap from 'bootstrap'; // full bootstrap
//import Collapse from 'bootstrap/js/dist/collapse'
require('./bootstrap/alert');
require('./bootstrap/collapse');
require('./bootstrap/dropdown');
require('./bootstrap/modal');
require('./bootstrap/offcanvas');
require('./bootstrap/tab');
require('./bootstrap/tooltip');

require('./front-components/navmenu');

document.addEventListener('DOMContentLoaded', () => {
	window.RS = new Theme();
});
